import { useEffect } from 'react';

interface UseTooltipClickOutsideProps {
  tooltipVisibility: { [key: string | number]: boolean };
  setTooltipVisibility: (visibility: {
    [key: string | number]: boolean;
  }) => void;
}

const useTooltipClickOutside = ({
  tooltipVisibility,
  setTooltipVisibility,
}: UseTooltipClickOutsideProps) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;

      const ignoredSelectors = [
        '.ant-tooltip-inner',
        '.ant-tooltip-trigger',
        '.ant-select-dropdown',
        '.ant-select',
        '.ant-picker-dropdown',
        '.ant-picker',
        '.ant-modal',
        '.ant-input',
        '.ant-dropdown',
        '.ant-popover',
      ];

      if (ignoredSelectors.some((selector) => target.closest(selector))) {
        return;
      }

      setTooltipVisibility({});
    };

    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [setTooltipVisibility]);
};

export default useTooltipClickOutside;
